import React from "react";
import styles from "./commoncard.module.scss"; // Import CSS Module

const CommonButton = ({ customClass, text, onClick, type = "primary", disabled = false }) => {
  return (
    <button
      className={` ${styles.button} ${styles[type]} ${customClass} `}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </button>
  );
};

export default CommonButton;
